var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWarningRed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#C8131B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 26,
    cy: 25.9996,
    r: 17.6129,
    fill: "#94090F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4259 33.4355C18.2731 33.4355 18.1342 33.3974 18.0092 33.321C17.8841 33.2446 17.7869 33.1439 17.7175 33.0189C17.648 32.8939 17.6098 32.7585 17.6029 32.6126C17.5959 32.4668 17.6341 32.3244 17.7175 32.1855L25.4269 18.8522C25.5103 18.7133 25.6179 18.6092 25.7499 18.5397C25.8819 18.4703 26.0173 18.4355 26.1562 18.4355C26.2951 18.4355 26.4306 18.4703 26.5625 18.5397C26.6945 18.6092 26.8021 18.7133 26.8855 18.8522L34.595 32.1855C34.6783 32.3244 34.7165 32.4668 34.7096 32.6126C34.7026 32.7585 34.6644 32.8939 34.595 33.0189C34.5255 33.1439 34.4283 33.2446 34.3033 33.321C34.1783 33.3974 34.0393 33.4355 33.8865 33.4355H18.4259ZM26.1562 30.9355C26.3924 30.9355 26.5903 30.8557 26.7501 30.696C26.9098 30.5362 26.9897 30.3383 26.9897 30.1022C26.9897 29.8661 26.9098 29.6682 26.7501 29.5085C26.5903 29.3487 26.3924 29.2689 26.1562 29.2689C25.9201 29.2689 25.7221 29.3487 25.5624 29.5085C25.4026 29.6682 25.3228 29.8661 25.3228 30.1022C25.3228 30.3383 25.4026 30.5362 25.5624 30.696C25.7221 30.8557 25.9201 30.9355 26.1562 30.9355ZM26.1562 28.4355C26.3924 28.4355 26.5903 28.3557 26.7501 28.196C26.9098 28.0362 26.9897 27.8383 26.9897 27.6022V25.1022C26.9897 24.8661 26.9098 24.6682 26.7501 24.5085C26.5903 24.3487 26.3924 24.2689 26.1562 24.2689C25.9201 24.2689 25.7221 24.3487 25.5624 24.5085C25.4026 24.6682 25.3228 24.8661 25.3228 25.1022V27.6022C25.3228 27.8383 25.4026 28.0362 25.5624 28.196C25.7221 28.3557 25.9201 28.4355 26.1562 28.4355Z",
    fill: "#C8131B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warningRed.376a2a05.svg";
export { ForwardRef as ReactComponent };